// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as React from "react";
import * as Chip$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/chip/Chip.bs.js";
import * as MuiTabs$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/tabs/MuiTabs.bs.js";
import * as CorePricingTableVm from "../vm-mapper/CorePricingTableVm.bs.js";

function getTabsList(campaigns) {
  switch (campaigns.TAG | 0) {
    case /* Live */1 :
        var campaignsVm = CorePricingTableVm.getVM(campaigns._0);
        return {
                hd: {
                  tabId: /* Active */0,
                  label: {
                    TAG: /* Text */0,
                    _0: "Active Campaigns"
                  },
                  icon: null,
                  disabled: false,
                  tooltip: undefined
                },
                tl: {
                  hd: {
                    tabId: /* Scheduled */1,
                    label: {
                      TAG: /* Custom */1,
                      _0: (function (param) {
                          return React.createElement("div", {
                                      className: "campaign-tab"
                                    }, "Future Campaigns", List.length(campaignsVm.scheduled) === 0 ? null : React.createElement(Chip$Catalyst.make, {
                                            title: {
                                              TAG: /* Text */0,
                                              _0: String(List.length(campaignsVm.scheduled))
                                            },
                                            className: "count"
                                          }));
                        })
                    },
                    icon: null,
                    disabled: false,
                    tooltip: undefined
                  },
                  tl: {
                    hd: {
                      tabId: /* Pending */2,
                      label: {
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            return React.createElement("div", {
                                        className: "campaign-tab"
                                      }, "Pending Campaigns", List.length(campaignsVm.pending) === 0 ? null : React.createElement(Chip$Catalyst.make, {
                                              title: {
                                                TAG: /* Text */0,
                                                _0: String(List.length(campaignsVm.pending))
                                              },
                                              className: "count"
                                            }));
                          })
                      },
                      icon: null,
                      disabled: false,
                      tooltip: undefined
                    },
                    tl: /* [] */0
                  }
                }
              };
    case /* Loading */0 :
    case /* Error */2 :
        break;
    
  }
  return {
          hd: {
            tabId: /* Active */0,
            label: {
              TAG: /* Text */0,
              _0: "Active Campaigns"
            },
            icon: null,
            disabled: false,
            tooltip: undefined
          },
          tl: {
            hd: {
              tabId: /* Scheduled */1,
              label: {
                TAG: /* Text */0,
                _0: "Future Campaigns"
              },
              icon: null,
              disabled: false,
              tooltip: undefined
            },
            tl: {
              hd: {
                tabId: /* Pending */2,
                label: {
                  TAG: /* Text */0,
                  _0: "Pending Campaigns"
                },
                icon: null,
                disabled: false,
                tooltip: undefined
              },
              tl: /* [] */0
            }
          }
        };
}

function CorePricingTableTabHeader(Props) {
  var campaigns = Props.campaigns;
  var activeTab = Props.activeTab;
  var setActiveTab = Props.setActiveTab;
  var tabs = getTabsList(campaigns);
  return React.createElement(MuiTabs$Catalyst.make, {
              tabs: tabs,
              activeTab: activeTab,
              setActiveTab: setActiveTab
            });
}

var make = CorePricingTableTabHeader;

export {
  getTabsList ,
  make ,
  
}
/* react Not a pure module */
